<template>
  <GenericInfo api-endpoint="device" :type="type" @add="addsave" @save="addsave">
    <template v-slot:title>
      <h1 v-if="type === 2">{{ $t('deviceInformation') }}</h1>
      <h1 v-else-if="type === 1">{{ $t('deviceEdit') }}</h1>
      <h1 v-else>{{ $t('addDevice') }}</h1>
    </template>
    <template v-slot:info>
      <p v-if="errorSNMessage" class="err-msg">{{ errorSNMessage }}</p>
      <div class="input-group-add">
        <label for="MAC" class="label-add">MAC:</label>
        <input
          type="text"
          id="MAC"
          name="MAC"
          placeholder="MAC"
          class="input-add"
          v-model="inputMACValue"
          @input="validateMACValue"
          :disabled="type !== 0"
        />
      </div>
      <p v-if="errorMACMessage" class="err-msg">{{ errorMACMessage }}</p>
      <div class="input-group-add">
        <label for="name" class="label-add">{{ $t('name') }}:</label>
        <input
          type="text"
          id="name"
          name="name"
          placeholder="name"
          class="input-add"
          v-model="inputNameValue"
          @input="validateNameValue"
          :disabled="type === 2"
        />
      </div>
    </template>
  </GenericInfo>
  <div class="group-add" style="height: 10px" />
  <DeviceInfoTabView :type="type" v-if="type === 2" />
  <div class="group-add" style="height: 10px" />
</template>

<script>
import { useRoute } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { ref, onMounted, inject } from 'vue';
import Swal from 'sweetalert2';
import { validateCString, validateMACAddress } from '../utils/stringValid';
import { fetchData, insertData, updateData } from '../utils/api';
import GenericInfo from '../generic/GenericInfo.vue';
import DeviceInfoTabView from './DeviceInfoTabView.vue';

export default {
  components: {
    GenericInfo,
    DeviceInfoTabView,
  },
  props: {
    type: {
      type: Number,
      default: 0,
    },
  },
  setup(props) {
    const { t } = useI18n();
    const route = useRoute();
    const page = ref('device');
    const btnLabel = ref(t('add'));
    const apiBaseUrl = inject('apiBaseUrl');
    const id = ref(0);
    const inputMACValue = ref('');
    const inputNameValue = ref('');

    const convertToMacAddress = (longInt) => {
      const hex = parseInt(longInt, 10).toString(16).padStart(12, '0');
      return hex.replace(/(.{2})(?=.)/g, '$1:').toUpperCase();
    };
    if (props.type !== 0) {
      onMounted(async () => {
        id.value = route.params.id;
        fetchData(t, `${apiBaseUrl}/info/${page.value}`, id.value).then((response) => {
          if (response.data) {
            inputMACValue.value = convertToMacAddress(response.data.result.MAC);
            inputNameValue.value = response.data.result.name;
          }
        });
      });
    }
    return {
      t,
      page,
      btnLabel,
      apiBaseUrl,
      id,
      inputMACValue,
      inputNameValue,
      route,
      convertToMacAddress,
    };
  },
  data() {
    return {
      errorSNMessage: '',
      errorMACMessage: '',
      errorNameMessage: '',
      errorVersionMessage: '',
      errorCreditMessage: '',
      title: this.$t('confirmAdd'),
    };
  },
  methods: {
    getData() {
      return JSON.stringify({
        id: this.route.params.id,
      });
    },
    validateMACValue() {
      if (validateMACAddress(this.inputMACValue)) {
        this.errorMACMessage = '';
        return true;
      }
      this.errorMACMessage = this.$t('incorrectFormat');
      return false;
    },
    validateNameValue() {
      if (validateCString(this.inputNameValue, 1, 24)) {
        this.errorNameMessage = '';
        return true;
      }
      this.errorNameMessage = this.$t('incorrectFormat');
      return false;
    },
    validateAllInputfield() {
      let check = 0;
      if (this.type !== 0) {
        this.title = this.$t('confirmSave');
      } else if (!this.validateMACValue()) {
        check += 1;
      }
      if (!this.validateNameValue()) {
        check += 1;
      }
      return check;
    },
    addsave() {
      if (this.validateAllInputfield() > 0) {
        Swal.fire({
          title: this.$t('checkFormatError'),
          icon: 'error',
        });
        return;
      }
      Swal.fire({
        icon: 'warning',
        title: this.title,
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
      }).then((result) => {
        if (result.isConfirmed) {
          if (this.type === 1) {
            const data = JSON.stringify({
              id: this.id,
              name: this.inputNameValue,
            });
            updateData(
              this.t,
              `${this.apiBaseUrl}/edit/${this.page}`,
              data,
              this.$router,
              '/device',
            );
          } else {
            const data = JSON.stringify({
              MAC: this.inputMACValue,
              name: this.inputNameValue,
            });
            insertData(
              this.t,
              `${this.apiBaseUrl}/new/${this.page}`,
              data,
              this.$router,
              '/device',
            );
          }
        }
      });
    },
  },
};
</script>
